import { Expose } from 'class-transformer';

export class ModelWdollarPackage {
    @Expose()
    id: number;

    @Expose()
    price: number;

    @Expose()
    discountText: string;

    @Expose()
    package: string;

    @Expose()
    ticket: string;

    @Expose()
    freePlay?: string;

    @Expose()
    freePlayText?: string;

    @Expose()
    text?: string;
}
